import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  spareParts: [],
  currentSparePartIndex: 0
};

const sparePartsSlice = createSlice({
  name: 'spareParts',
  initialState,
  reducers: {
    setSpareParts: (state, action) => {
      state.spareParts = action.payload;
    },
    updateSparePart: (state, action) => {
      const { index, field, value } = action.payload;
      if (state.spareParts[index]) {
        state.spareParts[index] = {
          ...state.spareParts[index],
          [field]: value
        };
      }
    },
    markSparePartAsDeleted: (state, action) => {
      const index = action.payload;
      if (state.spareParts[index]) {
        state.spareParts[index].is_deleted = true;
        if (index === state.currentSparePartIndex && index > 0) {
          state.currentSparePartIndex--;
        }
      }
    },
    addNewSparePart: (state) => {
      state.spareParts.push({
        priority: "",
        module_name: "",
        product_name: "",
        recommendations: "",
        photos: [],
        is_deleted: false
      });
      state.currentSparePartIndex = state.spareParts.length - 1;
    },
    setCurrentSparePartIndex: (state, action) => {
      state.currentSparePartIndex = action.payload;
    }
  }
});

export const {
  setSpareParts,
  updateSparePart,
  markSparePartAsDeleted,
  addNewSparePart,
  setCurrentSparePartIndex
} = sparePartsSlice.actions;

export default sparePartsSlice.reducer;